import { render, staticRenderFns } from "./ItemSignInWithEmail.vue?vue&type=template&id=68c4474a&scoped=true&lang=pug&"
import script from "./ItemSignInWithEmail.vue?vue&type=script&lang=js&"
export * from "./ItemSignInWithEmail.vue?vue&type=script&lang=js&"
import style0 from "./ItemSignInWithEmail.vue?vue&type=style&index=0&id=68c4474a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c4474a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
